module.exports = __webpack_public_path__ + "9a2db15976a99e6516c4c9c1b806f336.png";